/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceFilterRequest {
    getFixupPrototypeFunction() { return ComplianceFilterRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceFilterRequest>): ComplianceFilterRequest {
        let obj = Object.assign(new ComplianceFilterRequest(), model);
        ComplianceFilterRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceFilterRequest>): ComplianceFilterRequest {
        if (!model) return null;
        return ComplianceFilterRequest.newInstance(<ComplianceFilterRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceFilterRequest) {
        if (!obj) return;

        models.ComplianceFilterRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceFilterRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceFilterRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Specify the tenant IDs. This can be retrieved using the List Tenants API.
     */
    tenant_ids: Array<string>;

}
